import React, { useEffect, useState } from 'react'
import Wrapper from '../../assets/wrappers/DashboardLanding'
import TopHeader from '../../components/TopHeader'
import SabhaSaarHeader from '../../components/SabhaSaarHeader'
import { RootState } from '../../store';
import { useSelector, useDispatch } from 'react-redux';
import { getFinancialYr, setCurrentClickedMenu, setMeetingType } from '../../features/common/commonSlice';
import Select from "react-select";
import StateDashboard from './StateDashboard';
import ZillaParentDashboard from './Zila/ZillaParentDashboard';
import BlockParentDashboard from './Block/BlockParentDashboard';
import { fetchMeetingTypes } from '../../features/upload/uploadSlice';
import { useNavigate } from 'react-router-dom';
import GramParentDashboard from './Gram/GramParentDashboard';
import MultilingualDashboard from './MultiLingual/MultilingualDashboard';
import SabhaSaarHeaderPublic from '../../components/SabhaSaarHeaderPublic';


const FaMapMarkedAlt = require("react-icons/fa").FaMapMarkedAlt;
const FaCity = require("react-icons/fa").FaCity;
const FaLandmark = require("react-icons/fa").FaLandmark;
const FaHome = require("react-icons/fa").FaHome;
const FaLanguage = require("react-icons/fa").FaLanguage;
const FaHouseUser = require("react-icons/fa").FaHouseUser;


const DashboardLanding: React.FC = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { meetingTypes, loading, MeetingTypeFetched } = useSelector(
    (state: RootState) => state.upload
  );
  const { financialYr, currentFinYear, currentClickedMenu, meetingType,selectedFinYear } = useSelector(
    (state: RootState) => state.common
  );

  const [finYear, setFinYear] = useState<string>(selectedFinYear  || "");
  const [selectedMeeting, setSelectedMeeting] = useState<any>( meetingType || { value: 0, label: "All Meeting Types" });

  useEffect(() => {
    if (!MeetingTypeFetched && !loading) {
      dispatch(fetchMeetingTypes() as any);
    }
  }, [MeetingTypeFetched, loading, dispatch]);

  useEffect(() => {
    dispatch(getFinancialYr());
  }, [dispatch]);

const finYearOptions = [
  { value: "", label: "All" },
  ...financialYr.map((year) => ({
    value: year,
    label: year,
  })),
];

  const menuItems = [
    { name: "States", icon: <FaMapMarkedAlt /> },
    { name: "Zilla Panchayats", icon: <FaCity /> },
    { name: "Block Panchayats", icon: <FaLandmark /> },
    { name: "Gram Panchayats", icon: <FaHome /> },
    { name: "Multilingual Coverage", icon: <FaLanguage /> },
  ];

  const meetingTypeOptions = [
    {
      label: "All Meeting Types",
      options: [
        { value: 0, label: "All Meeting Types" },
      ],
    },
    ...(meetingTypes?.map((parent) => ({
      label: parent.name,
      options: parent.sub_options.map((sub: any) => ({
        value: sub.id,
        label: sub.name,
      })),
    })) || []),
  ];

  const dashboardComponents: Record<string, React.FC<{ finYear: string; meetingType: any }>> = {
    "States": StateDashboard,
    "Zilla Panchayats": ZillaParentDashboard,
    "Block Panchayats": BlockParentDashboard,
    "Gram Panchayats": GramParentDashboard,
    "Multilingual Coverage": MultilingualDashboard,
  };

  const active = currentClickedMenu;
  return (
    <Wrapper>
      <TopHeader />
      <section className="body-content">
        <div className="row">
          <SabhaSaarHeaderPublic />
        </div>
        <div className="row mt-2">
          <div className="col-md-2 mt-3">
            <div className="card bx-shd">
              <div className="home-strip " onClick={() => navigate("/")}>
                <FaHouseUser className="home-icon" /> <span className="home-icon"> Home </span>
              </div>
              <div className="card-body">

                <ul>
                  {menuItems.map((item) => (
                    <li
                      key={item.name}
                      className={`sidebar-item ${active === item.name ? "active" : ""}`}
                      onClick={() => dispatch(setCurrentClickedMenu(item.name))}
                    >
                      <span className="icon">{item.icon}</span>
                      <span>{item.name}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
          <div className="col-md-10 mt-3">
            <div className="card bx-shd">
              <div className="card-body">
                <div className="dashboard-header flex justify-content-between gap-3">
                  <h2 className="dashboard-heading2 mb-2 md:mb-0">{active} View</h2>
                  <div className="handleDropdown flex flex-col sm:flex-row gap-3 w-full md:w-auto">
                    <Select
                      className="w-full sm:w-64"
                      placeholder="Select Financial Year"
                      value={finYearOptions.find((opt) => opt.value === finYear)}
                      onChange={(selected) => setFinYear(selected?.value || "")}
                      options={finYearOptions}
                      isSearchable={false}
                      styles={{
                        control: (base) => ({
                          ...base,
                          borderRadius: "0.5rem",
                          boxShadow: "none",
                          borderColor: "#ccc",
                        }),
                      }}
                    />
                    <Select
                      className="w-full sm:w-64"
                      placeholder="Select Meeting Type"
                      value={selectedMeeting}
                      onChange={(selected) => {
                        setSelectedMeeting(selected);
                        dispatch(setMeetingType(selected));
                      }}
                      options={meetingTypeOptions}
                      isSearchable={true}
                      styles={{
                        control: (base) => ({
                          ...base,
                          borderRadius: "0.5rem",
                          boxShadow: "none",
                          borderColor: "#ccc",
                        }),
                        menu: (base) => ({
                          ...base,
                          minWidth: "250px",
                        }),
                      }}
                    />
                  </div>
                </div>

                <div className="mt-3">
                  {(() => {
                    const Component = dashboardComponents[active];
                    return Component ? (
                      <Component finYear={finYear} meetingType={selectedMeeting} />
                    ) : null;
                  })()}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Wrapper>
  )
}

export default DashboardLanding;
